import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        list: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('tickets_min', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        getTicket: (cntx, params) => {
            const { barcode } = params
            return new Promise((resolve, reject) => {
                axios.get(`tickets?query=${barcode}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        show: (cntx, { id }) => {
            axios.get(`tickets/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
        },
        create: (cntx, params) => new Promise((resolve, reject) => {
            axios.post('tickets', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        update: (cntx, params) => new Promise((resolve, reject) => {
            axios.put(`tickets/${params.id}`, params.data)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        remove: (cntx, id) => new Promise((resolve, reject) => {
            axios.delete(`tickets/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        seasons: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('seasons', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        buyers: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('buyers', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        societies: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('societies', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        markets: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('markets', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        sales: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('sales', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        grades: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('grades', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        growers: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('growers', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        classifiers: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('classifiers', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        registrationNumbers: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('registration_numbers', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        query: (cntx, params) => new Promise((resolve, reject) => {
            axios.post('ticket_transactions', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
    },
}
